<script lang="ts">
  import type { Snippet } from 'svelte';
  import { user, authReady } from '../lib/stores/auth';
  import Navigate from './Navigate.svelte';
  import Spinner from './ui/Spinner.svelte';

  // Wraps the body of routes that require a signed-in user. Three states:
  //   1. authReady=false → render the spinner (boot still in flight)
  //   2. authReady=true, user=null → redirect to /login (preserve return path
  //      via ?next= so we can bounce back after sign-in)
  //   3. authReady=true, user set → render children
  //
  // The redirect target uses location.pathname + search so query params
  // survive the round-trip too (matters for shareable account-tab links).

  interface Props {
    /** Override the default /login redirect (e.g. /register/finish for OAuth). */
    redirectTo?: string;
    children: Snippet;
  }

  let { redirectTo = '/login', children }: Props = $props();

  const nextParam = $derived.by(() => {
    if (typeof window === 'undefined') return '';
    const here = window.location.pathname + window.location.search;
    if (here === '/' || here === redirectTo) return '';
    return `?next=${encodeURIComponent(here)}`;
  });
</script>

{#if !$authReady}
  <div class="page-center"><Spinner size="lg" /></div>
{:else if !$user}
  <Navigate to="{redirectTo}{nextParam}" replace />
{:else}
  {@render children()}
{/if}
